import {
  CRMContactDetails,
  CRMContactList,
  WorkTasks,
  WorkTasksPlanning,
  WorkTaskDetails,
  Maintenance,
  MaintenancePlanning,
  AnalyticsDashboard,
  AnalyticsSalesReport,
  AnalyticsGeography,
  SignInPage,
  SignUpPage,
  ResetPasswordPage,
  EmployeeList,
  EmployeeDetails,
  TenantAdmin,
  TenantDetails,
  ActivityManagement,
  ContractTypeManagement,
  EmailDesigner,
  CompanySettingsPage,
} from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
  {
    path: '/crm-contact-details',
    element: CRMContactDetails,
  },
  {
    path: '/crm-contact-list',
    element: CRMContactList,
  },
  {
    path: '/worktasks-planning',
    element: WorkTasksPlanning,
  },
  {
    path: '/worktask-details',
    element: WorkTaskDetails,
  },
  {
    path: '/maintenance',
    element: Maintenance,
  },
  {
    path: '/maintenance-planning',
    element: MaintenancePlanning,
  },
  {
    path: '/analytics-dashboard',
    element: AnalyticsDashboard,
  },
  {
    path: '/analytics-sales-report',
    element: AnalyticsSalesReport,
  },
  {
    path: '/analytics-geography',
    element: AnalyticsGeography,
  },
  {
    path: '/sign-in-form',
    element: SignInPage,
  },
  {
    path: '/sign-up-form',
    element: SignUpPage,
  },
  {
    path: '/reset-password-form',
    element: ResetPasswordPage,
  },
  {
    path: '/employees',
    element: EmployeeList,
  },
  {
    path: '/employee-details',
    element: EmployeeDetails,
  },
  {
    path: '/work-tasks',
    element: WorkTasks,
  },
  {
    path: '/tenant-admin',
    element: TenantAdmin,
  },
  {
    path: '/tenant-details',
    element: TenantDetails,
  },
  {
    path: '/activity-management',
    element: ActivityManagement,
  },
  {
    path: '/contract-type-management',
    element: ContractTypeManagement,
  },
  {
    path: '/email-designer',
    element: EmailDesigner,
  },
  {
    path: '/company-settings',
    element: CompanySettingsPage,
  },
];

export const appRoutes = routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
